import {Flex,SkeletonCircle,SkeletonText,TableContainer,Table,Thead, Tbody,Th,Tr,Td, Box,Alert, MenuItem,
    AlertTitle, AlertDescription, AlertIcon,  Text, Input, InputLeftElement, Menu,Tooltip,MenuButton,MenuList,
    InputGroup,  Spacer,  ButtonGroup, Button } from '@chakra-ui/react';
import {SearchIcon, CloseIcon} from '@chakra-ui/icons';
import { ChevronDownIcon } from '@chakra-ui/icons';

import { useState, useEffect, useRef } from 'react';
import { getGovedaNaFarmi,  getGovedaBeforeOmigracijaId } from '../../util/apiGovedo';
import GruntPager from '../custom/GruntPager';
import { getKnjigeShort } from '../../util/apiKnjiga';
function GovedoSearch({knjiga_id=0,naslov,onSelect,onClose,preselectedgoveda=[],omigracijaid=0,size='xs',rowsperpage=15,showButtonOdustani=true}) {
    const [state,setState]=useState({goveda:[],errmsg:""/*,curpage:0,rowsperpage:5, pages:0*/, filter:""})
    const [prikaz, setPrikaz] = useState({rowsperpage:rowsperpage,currpage:1,numOfRowsToShow:0,selectallgoveda:false,numberofselected:0})
    const [dataisloading, setDataisloading] = useState(true);
    const [knjige,setKnjige]=useState([]);
    const [knjid,setKnjid]=useState(knjiga_id);
    const [knjnaz,setKnjNaz]=useState("");
    const srchGrloRef=useRef(null);

    const fetchData=async()=>{
      try {
        let _numselected=0;
        let res;
        
        
        if (omigracijaid>0) {
            res=await getGovedaBeforeOmigracijaId({knjigaid:knjid,omigracijaid:omigracijaid});
        } else {
          
            res=await getGovedaNaFarmi({knjigaid:knjid});
          
            
        }
        if (res.status===200) {
          let _gov=res.res;
          
          let _i=0;
          while (_i<_gov.length) {
            _gov[_i].selected=false;
            if (preselectedgoveda.includes(_gov[_i].govedo_id)) {
              _gov[_i].selected=true;
              _numselected++;
            }
            
            _gov[_i].filtered=true;
            _i++;
          }
          setState({...state,goveda:_gov,pages:Math.floor(_gov.length/state.rowsperpage)});
          setPrikaz({...prikaz,numOfRowsToShow:_gov.length,numberofselected:_numselected});
        } else {
          throw new Error(res.message);
        }

      } catch (error) {
        setState({...state,errmsg:error.message});
      } finally {
        setDataisloading(false);
      }
    }

    useEffect(() => {
      setDataisloading(true);
      fetchData();
    }, [knjid])

    useEffect(() => {
      const fetchKnjige=async()=>{
        try {
            const _r=await getKnjigeShort();
            if (_r.status===200) {
                setKnjige(_r.res);
                const _idx=_r.res.findIndex((item)=>item.id===knjiga_id);
                if (_idx!==-1) {
                    setKnjNaz(_r.res[_idx].naziv);
                } else {
                    setKnjNaz("Knjige")
                }
            }
        } catch (error) {
            setState({...state,errmsg:error.message});
        }
      }
      fetchKnjige();
    }, [])
    const changeKnjiga=(_knjid,_knjnaziv)=>{
        setKnjid(_knjid);
        setKnjNaz(_knjnaziv);
    }
    
    const buildMenuButtonKnjige=()=>{
        let i=0;
        let b=true;
        return (
            <Menu placement={'bottom'} preventOverflow={true}>
                 <Tooltip label={'Odabir pasmine'} placement={'top-start'}>
                    <MenuButton as={Button}
                      aria-label='Options'
                      variant={'solid'}
                      colorScheme={'grunt2'}
                      w={'10rem'}
                      size={'xs'}>
                        <Box display={'flex'} flexDir={'row'} alignItems={'center'}>
                            
                                Knjiga ({knjnaz})
                                <Spacer/>
                                <ChevronDownIcon/>
                            
                            
                        </Box>
                      
                      </MenuButton>
                    
                  </Tooltip>
                    <MenuList overflow={'visible'} zIndex={10} placement={'bottom'}>
                        {
                            knjige.map((item,index)=>{
                              return (
                                <MenuItem fontSize={'xs'} onClick={()=>changeKnjiga(item.id,item.naziv)}>
                                  {item.naziv}
                                </MenuItem>
                              )
                            })
                        }
                      
                    </MenuList>
              </Menu>
        )
    }
    const SetFilter=(e)=>{
        //const _val=e.target.value;
        let _ar=state.goveda;
       /* let _i=0;
        _ar.forEach((gov)=>{
          if (gov.zivbr.includes(_val)  || _val==="") {
            gov.filtered=true;
            _i++;
          } else {
            gov.filtered=false;
          }
        })*/
        const _val0=e.target.value.toUpperCase();
        const _val=_val0.replaceAll("_",".").replaceAll("*",".*");

        const _rgxstr="^.*" + _val+"$"; 
        const _r=new RegExp(_rgxstr);
        let _test=false;
        let _i=0;
        _ar.forEach((gov)=>{
          _test=_r.test(gov.zivbr) || _val0==="";
          gov.filtered=_test;
          if (_test) {
            _i++;
          }

        })
        
        

        setState({...state,goveda:_ar,filter:_val0});
        setPrikaz({...prikaz,numOfRowsToShow:_i});
        
    }

    const ShowError=()=>{
      if (state.errmsg!=="") {
          return (
              <Alert status='error'>
                  <AlertIcon />
                  <AlertTitle>Greška kod dohvata podataka</AlertTitle>
                  <AlertDescription>{state.errmsg}</AlertDescription>
              </Alert>
          )
      }
  }

const selectGovedo=(govedoid)=>{
    
    let _idx=state.goveda.findIndex((item)=>item.govedo_id=govedoid);
    if (_idx!==-1) {
        onSelect(state.goveda[_idx]);
        onClose();
    }

    
}





  const ShowGovedaList=()=>{
    let _ar=state.goveda.filter((gov)=>{
      return gov.filtered===true;
    })
    return(
        <TableContainer>
        <Table size={'xs'}>
            <Thead _hover={{cursor:'pointer'}}>
                <Tr>
                    
                    <Th fontSize={size} textAlign={'center'} zIndex='5' pos={'sticky'} top='0' color={'grunt2.800'} borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'}>Životni broj</Th>
                    <Th fontSize={size} textAlign={'center'} zIndex='5' pos={'sticky'} top='0' color={'grunt2.800'} borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'}>Spol</Th>
                    <Th fontSize={size} textAlign={'center'} zIndex='5' pos={'sticky'} top='0' color={'grunt2.800'} borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'}>Pasmina</Th>
                    <Th fontSize={size} textAlign={'center'} zIndex='5' pos={'sticky'} top='0' color={'grunt2.800'} borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'}>Datum dolaska</Th>
                    <Th fontSize={size} textAlign={'center'} zIndex='5' pos={'sticky'} top='0' color={'grunt2.800'} borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'}>Rfid</Th>
                    <Th fontSize={size} textAlign={'center'} zIndex='5' pos={'sticky'} top='0' color={'grunt2.800'} borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'} borderTopRightRadius={'sm'}>Oznaka</Th>
                    
                </Tr>
            </Thead>
        <Tbody>
            {_ar.slice((prikaz.currpage-1)*prikaz.rowsperpage,(prikaz.currpage)*prikaz.rowsperpage).map((item,index)=>{
                
                    return (
                        <Tr  color={'grunt2'} key={item.govedo_id}  bg={'white'} fontWeight={'normal'} 
                                _hover={{bg:'gray.100',cursor:'pointer'}} onClick={()=>handleClick(item.govedo_id)} h={'2rem'}>
                                   
                                    <Td fontSize={size} textAlign={'center'}>{item.zivbr}</Td>
                                    <Td fontSize={size} textAlign={'center'}>{item.spol}</Td>
                                    <Td fontSize={size} textAlign={'center'}>{item.pasmina_naziv}</Td>
                                    <Td fontSize={size} textAlign={'center'}>{new Date(item.datum_dolazak).toLocaleDateString('hr-HR')}</Td>
                                    <Td fontSize={size} textAlign={'center'}>{item.rfid}</Td>
                                    <Td fontSize={size} textAlign={'center'}>{item.putnica_oznaka}</Td>
                                </Tr>
                    )    
                
                
            })}
        </Tbody>
        </Table>
        </TableContainer>
    )
}
//srchGrloRef.current.focus();
const handleClick=(id)=>{
  selectGovedo(id);
  srchGrloRef.current.focus();
  srchGrloRef.current.select();
}



const showGoveda=()=>{
  if (dataisloading) {
    return (
      <Box display={'flex'} flexDir={'column'} gap={'0.5rem'} w='100%'>
          <SkeletonCircle size='10' />
          <SkeletonText mt='4' noOfLines={10} spacing='4' skeletonHeight='2' />
      </Box>
    )
  } else {
    return (
      <Box>
            <Flex direction={'row'} bg={'grunt2.100'} rounded={'sm'}>
                <Text fontSize={size} ml={'0.5rem'} fontWeight={'semibold'}>{naslov}</Text>
                <Spacer/>
                {/* <CloseButton size={'sm'} m={'auto'} onClick={onClose}/> */}
            </Flex>
            <Flex direction={'row'} alignItems={'center'}>
              <InputGroup size={size} m={'0.5rem'} w={'20rem'} alignContent={'center'}>
                  <InputLeftElement h={'full'} pointerEvents={'none'} children={<SearchIcon/>}></InputLeftElement>
                  <Input focusBorderColor='grunt2.400' ref={srchGrloRef} value={state.filter} variant={'outline'} placeholder={'* (više znakova), _ (jedan znak)'} w={'20rem'} onChange={SetFilter}></Input>
              </InputGroup>
              
              {buildMenuButtonKnjige()}
              <Spacer/>
              <ButtonGroup>
                
                {showButtonOdustani?<Button size={size} colorScheme='grunt2' variant={'outline'} onClick={onClose}>Odustani</Button>:null}
                
              </ButtonGroup>
            </Flex>
            {ShowError()} 
            {ShowGovedaList()}
            
            <GruntPager currpage={prikaz.currpage} rowcount={prikaz.numOfRowsToShow} rowsperpage={prikaz.rowsperpage} onClick={(pagenum)=>setPrikaz({...prikaz,currpage:pagenum})}/>
            <Spacer/>
      </Box>
    )
  }
}
  return (
  
    
    <Box flexDirection={'column'} fontSize={'sm'} overflow={'hidden'}>
         {showGoveda()}
    </Box>
    
  )
}

export default GovedoSearch